<template>
  <hr />
</template>

<style scoped lang="scss">
hr {
  border-top: 1px solid;
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
  @apply border-dividers-default;
}
</style>
